import { createAction, props } from '@ngrx/store';
import { ErrorResponse } from '@core/models';
import { PromoCode } from '@api/backend';

export const promoCodeActions = {
  getList: createAction(
    '[Promo Code] Get List Promo Code',
  ),
  getListSuccess: createAction(
    '[Promo Code] Get List Promo Code Success',
    props<{ promoCodes: Array<PromoCode> }>(),
  ),
  getListFailure: createAction(
    '[Promo Code] Get List Promo Code Failure',
    props<{ error: ErrorResponse }>(),
  ),
  validate: createAction(
    '[Promo Code] Validate Promo Code',
    props<{ code: string }>(),
  ),
  validateSuccess: createAction(
    '[Promo Code] Validate Promo Code Success',
    props<{ promoCode: PromoCode }>(),
  ),
  validateFailure: createAction(
    '[Promo Code] Validate Promo Code Failure',
    props<{ error: ErrorResponse }>(),
  ),
  apply: createAction(
    '[Promo Code] Apply Promo Code',
    props<{ code: string }>(),
  ),
  applySuccess: createAction(
    '[Promo Code] Apply Promo Code Success',
  ),
  applyFailure: createAction(
    '[Promo Code] Apply Promo Code Failure',
    props<{ error: ErrorResponse }>(),
  ),
  reset: createAction(
    '[Promo Code] Reset Promo Code',
  ),
};